import { render, staticRenderFns } from "./LayoutSidebar.vue?vue&type=template&id=ed8edebe&scoped=true&"
import script from "./LayoutSidebar.vue?vue&type=script&lang=js&"
export * from "./LayoutSidebar.vue?vue&type=script&lang=js&"
import style0 from "./LayoutSidebar.vue?vue&type=style&index=0&id=ed8edebe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed8edebe",
  null
  
)

export default component.exports